import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _VEHICLE_STATUS_LABEL, _COLUMN_PAYMENT_TYPE_;

import { DEALER_PROPERTY } from 'tbase/constants/dealer/dealerLogo.constants';
import { DEAL_STATUS } from './deal.constants';
import { PAYMENT_TYPES } from './desking.constants';
export var TAGS = {
  START_DEAL: 'START_DEAL',
  UPDATE_DEAL: 'UPDATE_DEAL',
  DESKING_TABLE: 'DESKING_TABLE',
  DESKING_HEADER: 'DESKING_HEADER',
  DESKING_SUB_HEADER: 'DESKING_SUB_HEADER'
};
export var TABLE_CONFIG = {
  ROW_HEIGHT: 40,
  PAGE_SIZE: 20
};
export var PREFERENCE_ASSET_TYPE = {
  VEHICLE: 'DEAL_VI',
  CUSTOMER: 'DEAL_CUSTOMER',
  LEADS: 'DEAL_LEADS',
  CHROME_VEHICLE_BUILDER_OPTIONS: 'CHROME_VEHICLE_BUILDER_OPTIONS'
};
export var TOASTER_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info'
};
export var DEAL_HEADER_ITEMS = {
  DEAL_COUNT: 'vehicleAggKpi',
  PERFORMANCE_INDEX: 'piKpi',
  PVR: 'pvrKpi',
  GROSS: 'grossKpi',
  DEALS_WITH_ZERO_GL_BALANCE: 'dealsWithZeroGLBalance'
};
export var EMPTY_PLACEHOLDERS = {
  NOT_AVAILABLE: '–'
};
export var VALIDATION_STATUS = {
  PASSED: 'PASSED',
  FAILED: 'FAILED'
};
export var DESKING_TABS_VALIDATION = {
  CASHIERING: DEAL_STATUS.BOOKED
};
export var VEHICLE_STATUS = {
  DRAFT: 'DRAFT',
  STOCKED_IN: 'STOCKED_IN',
  FLOAT: 'FLOAT',
  IN_TRANSIT: 'IN_TRANSIT',
  INVOICE_RECEIVED: 'INVOICE_RECEIVED',
  IN_PRODUCTION: 'IN_PRODUCTION',
  ON_ORDER: 'ON_ORDER',
  SOLD: 'SOLD',
  RETIRED: 'RETIRED',
  ON_HOLD: 'ON_HOLD',
  RECEIVED: 'RECEIVED'
};
export var VEHICLE_STATUS_LABEL = (_VEHICLE_STATUS_LABEL = {}, _defineProperty(_VEHICLE_STATUS_LABEL, VEHICLE_STATUS.DRAFT, __('Draft')), _defineProperty(_VEHICLE_STATUS_LABEL, VEHICLE_STATUS.STOCKED_IN, __('Stocked In')), _defineProperty(_VEHICLE_STATUS_LABEL, VEHICLE_STATUS.FLOAT, __('Float')), _defineProperty(_VEHICLE_STATUS_LABEL, VEHICLE_STATUS.IN_TRANSIT, __('In Transit')), _defineProperty(_VEHICLE_STATUS_LABEL, VEHICLE_STATUS.INVOICE_RECEIVED, __('Invoice Received')), _defineProperty(_VEHICLE_STATUS_LABEL, VEHICLE_STATUS.IN_PRODUCTION, __('In Production')), _defineProperty(_VEHICLE_STATUS_LABEL, VEHICLE_STATUS.ON_ORDER, __('On Order')), _defineProperty(_VEHICLE_STATUS_LABEL, VEHICLE_STATUS.SOLD, __('Sold')), _defineProperty(_VEHICLE_STATUS_LABEL, VEHICLE_STATUS.RETIRED, __('Retired')), _defineProperty(_VEHICLE_STATUS_LABEL, VEHICLE_STATUS.ON_HOLD, __('On Hold')), _defineProperty(_VEHICLE_STATUS_LABEL, VEHICLE_STATUS.RECEIVED, __('Received')), _VEHICLE_STATUS_LABEL);
export var PUSHER_MESSAGES = {
  DEAL_JACKET_DOWNLOADED: 'DEAL_JACKET_DOWNLOADED',
  PREVIEW_CREATED: 'PREVIEW_CREATED',
  PRINT_CREATED: 'PRINT_CREATED',
  DEAL_LOCK_ACQUIRED: 'DEAL_LOCK_ACQUIRED',
  CREDIT_FEEDBACK_SAVED: 'CREDIT_FEEDBACK_SAVED',
  CREDIT_FEEDBACK_NOT_SAVED: 'CREDIT_FEEDBACK_NOT_SAVED',
  CREDIT_ECONTRACT_FAULT_SAVED: 'ECONTRACT_FAULT_SAVED',
  FORM_PRINTING_FAILED: 'FORM_PRINTING_FAILED',
  FORM_SIGN_STATUS_UPDATE: 'FORM_SIGN_STATUS_UPDATE',
  PDF_ZIPPED: 'PDF_ZIPPED',
  PDF_MERGED: 'PDF_MERGED'
};
export var API_STATUS = {
  SUCCESS: 'success'
};
export var VERSION_ERROR_CODES = {
  VERSION_MISMATCH: 'SALES_VER100',
  VERSION_MISMATCH_UNWIND: 'SALES_VER100_UNWIND'
};
export var REBATE_PAYMENT_TYPE_CODES = {
  SPECIAL_LEASE: 1,
  STANDARD_LEASE: 2,
  SPECIAL_RETAIL: 3,
  STANDARD_RETAIL: 4,
  CASH: 5,
  LEASE: 10,
  RETAIL: 11,
  ALL_PAYMENT_TYPES: 1000
};
var RETAIL_COLUMN_PAYMENT_TYPE_CODES = [REBATE_PAYMENT_TYPE_CODES.ALL_PAYMENT_TYPES, REBATE_PAYMENT_TYPE_CODES.SPECIAL_RETAIL, REBATE_PAYMENT_TYPE_CODES.STANDARD_RETAIL, REBATE_PAYMENT_TYPE_CODES.RETAIL];
var LEASE_COLUMN_PAYMENT_TYPE_CODES = [REBATE_PAYMENT_TYPE_CODES.ALL_PAYMENT_TYPES, REBATE_PAYMENT_TYPE_CODES.SPECIAL_LEASE, REBATE_PAYMENT_TYPE_CODES.STANDARD_LEASE, REBATE_PAYMENT_TYPE_CODES.LEASE];
var CASH_COLUMN_PAYMENT_TYPE_CODES = [REBATE_PAYMENT_TYPE_CODES.ALL_PAYMENT_TYPES, REBATE_PAYMENT_TYPE_CODES.CASH];
export var COLUMN_PAYMENT_TYPE_VS_CODE = (_COLUMN_PAYMENT_TYPE_ = {}, _defineProperty(_COLUMN_PAYMENT_TYPE_, PAYMENT_TYPES.LOAN, RETAIL_COLUMN_PAYMENT_TYPE_CODES), _defineProperty(_COLUMN_PAYMENT_TYPE_, PAYMENT_TYPES.CASH, CASH_COLUMN_PAYMENT_TYPE_CODES), _defineProperty(_COLUMN_PAYMENT_TYPE_, PAYMENT_TYPES.LEASE, LEASE_COLUMN_PAYMENT_TYPE_CODES), _defineProperty(_COLUMN_PAYMENT_TYPE_, PAYMENT_TYPES.ONE_TIME_LEASE, LEASE_COLUMN_PAYMENT_TYPE_CODES), _defineProperty(_COLUMN_PAYMENT_TYPE_, PAYMENT_TYPES.BALLOON, RETAIL_COLUMN_PAYMENT_TYPE_CODES), _COLUMN_PAYMENT_TYPE_);
export var DEALER_PROPS_TO_FETCH = [DEALER_PROPERTY.NEW_DSE_ENABLED];